export const topCasinos = [
  {
    id: 1,
    name: 'Vavada Casino',
    rating: 4.9,
    bonus: '100% до 50 000 ₽',
    features: ['Быстрый вывод', 'Бонусы', 'Поддержка 24/7'],
    image: 'https://public.readdy.ai/ai/img_res/f48edb789f9c6321e2edefd995434e64.jpg',
    bgColor: 'bg-rose-100',
    withdrawTime: '5-15 мин',
    games: 2500,
    license: 'Кюрасао',
    paymentMethods: ['Карты РФ', 'СБП', 'ЮMoney', 'Qiwi'],
    minDeposit: 500,
    wagerRequirement: 'x35'
  },
  {
    id: 2,
    name: 'Pin-Up Casino',
    rating: 4.8,
    bonus: '120% + 250 FS',
    features: ['Live дилеры', 'Мобильное приложение', 'Криптовалюты'],
    image: 'https://readdy.ai/api/search-image?query=vibrant%20online%20casino%20gaming%20interface%20with%20neon%20lights%20and%20slot%20machine%20symbols%20on%20mint%20green%20turquoise%20background%2C%20modern%20digital%20gambling%20design%2C%20sleek%20professional%20style%2C%20premium%203d%20illustration&width=400&height=500&seq=2&orientation=portrait',
    bgColor: 'bg-emerald-100',
    withdrawTime: '10-20 мин',
    games: 3200,
    license: 'Кюрасао',
    paymentMethods: ['Карты РФ', 'СБП', 'Криптовалюты'],
    minDeposit: 1000,
    wagerRequirement: 'x40'
  },
  {
    id: 3,
    name: '1xSlots',
    rating: 4.7,
    bonus: '150% + 200 FS',
    features: ['Турниры', 'Кэшбэк', 'VIP программа'],
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20casino%20gaming%20platform%20with%20roulette%20wheel%20and%20poker%20chips%20on%20soft%20gray%20silver%20background%2C%20elegant%20online%20gambling%20interface%2C%20minimalist%20luxury%20design%2C%20high%20end%203d%20rendering&width=400&height=500&seq=3&orientation=portrait',
    bgColor: 'bg-slate-100',
    withdrawTime: '15-30 мин',
    games: 4000,
    license: 'Кюрасао',
    paymentMethods: ['Все методы', 'Криптовалюты'],
    minDeposit: 500,
    wagerRequirement: 'x45'
  },
  {
    id: 4,
    name: 'Joycasino',
    rating: 4.6,
    bonus: '200% + 200 FS',
    features: ['Быстрая регистрация', 'Без верификации', 'Бонус каждый день'],
    image: 'https://readdy.ai/api/search-image?query=warm%20inviting%20casino%20interface%20with%20dice%20and%20card%20symbols%20on%20soft%20peach%20amber%20background%2C%20friendly%20online%20gambling%20platform%20design%2C%20modern%20approachable%20style%2C%20quality%203d%20visualization&width=400&height=500&seq=4&orientation=portrait',
    bgColor: 'bg-amber-100',
    withdrawTime: '10-25 мин',
    games: 2800,
    license: 'Кюрасао',
    paymentMethods: ['Карты РФ', 'СБП', 'ЮMoney'],
    minDeposit: 500,
    wagerRequirement: 'x40'
  },
  {
    id: 5,
    name: 'Riobet',
    rating: 4.8,
    bonus: '100% + 100 FS',
    features: ['Спортивные ставки', 'Live казино', 'Быстрый вывод'],
    image: 'https://readdy.ai/api/search-image?query=premium%20casino%20gaming%20interface%20with%20golden%20crown%20and%20luxury%20symbols%20on%20deep%20purple%20violet%20background%2C%20exclusive%20online%20gambling%20platform%2C%20sophisticated%20elegant%20design%2C%20professional%203d%20render&width=400&height=500&seq=5&orientation=portrait',
    bgColor: 'bg-purple-100',
    withdrawTime: '5-10 мин',
    games: 3500,
    license: 'Кюрасао',
    paymentMethods: ['Карты РФ', 'СБП', 'Криптовалюты'],
    minDeposit: 1000,
    wagerRequirement: 'x35'
  },
  {
    id: 6,
    name: 'Vulkan Vegas',
    rating: 4.7,
    bonus: '100% + 50 FS',
    features: ['Проверенное казино', 'Русский интерфейс', 'Лояльность'],
    image: 'https://readdy.ai/api/search-image?query=classic%20casino%20interface%20with%20playing%20cards%20and%20chips%20on%20soft%20blue%20sky%20background%2C%20reliable%20online%20gambling%20platform%20design%2C%20trustworthy%20professional%20style%2C%20clean%203d%20illustration&width=400&height=500&seq=6&orientation=portrait',
    bgColor: 'bg-sky-100',
    withdrawTime: '15-30 мин',
    games: 2600,
    license: 'Кюрасао',
    paymentMethods: ['Карты РФ', 'ЮMoney', 'Qiwi'],
    minDeposit: 500,
    wagerRequirement: 'x40'
  },
  {
    id: 7,
    name: 'Starda Casino',
    rating: 4.9,
    bonus: '100% + 200 FS',
    features: ['Новое казино', 'Щедрые бонусы', 'Мгновенный вывод'],
    image: 'https://readdy.ai/api/search-image?query=modern%20innovative%20casino%20platform%20with%20futuristic%20elements%20and%20gaming%20symbols%20on%20soft%20pink%20rose%20background%2C%20fresh%20online%20gambling%20interface%2C%20contemporary%20stylish%20design%2C%20premium%203d%20rendering&width=400&height=500&seq=7&orientation=portrait',
    bgColor: 'bg-pink-100',
    withdrawTime: '5-15 мин',
    games: 3000,
    license: 'Кюрасао',
    paymentMethods: ['Карты РФ', 'СБП', 'Криптовалюты'],
    minDeposit: 500,
    wagerRequirement: 'x35'
  },
  {
    id: 8,
    name: 'Drip Casino',
    rating: 4.6,
    bonus: '100% + 100 FS',
    features: ['Криптовалюты', 'Анонимность', 'Без KYC'],
    image: 'https://readdy.ai/api/search-image?query=sleek%20digital%20casino%20interface%20with%20cryptocurrency%20symbols%20and%20modern%20elements%20on%20soft%20teal%20cyan%20background%2C%20innovative%20online%20gambling%20platform%2C%20cutting%20edge%20design%2C%20high%20quality%203d%20visualization&width=400&height=500&seq=8&orientation=portrait',
    bgColor: 'bg-teal-100',
    withdrawTime: '10-20 мин',
    games: 2400,
    license: 'Кюрасао',
    paymentMethods: ['Криптовалюты', 'Карты РФ'],
    minDeposit: 1000,
    wagerRequirement: 'x40'
  }
];